<template>
  <div
    v-show="show && !disabled"
    class="flex px-5 py-5"
    aria-label="Breadcrumb"
  >
    <ol role="list" class="flex items-center space-x-4">
      <li>
        <div class="flex">
          <router-link
            :to="{ name: 'index' }"
            class="text-sm font-medium text-gray-500 hover:text-gray-700"
          >
            {{ $t("message.home") }}
          </router-link>
        </div>
      </li>
      <template v-if="!preset">
        <span v-for="(breadcrumb, index) in breadcrumbs" :key="index">
          <li>
            <div class="flex items-center">
              <ChevronRightIcon
                class="flex-shrink-0 h-5 w-5 text-gray-400"
                aria-hidden="true"
              />

              <router-link
                v-if="!breadcrumb.isLast"
                :to="{
                  name: breadcrumb.name,
                  params: breadcrumb.params,
                  query: breadcrumb.query,
                }"
                class="
                  ml-4
                  text-sm
                  font-medium
                  text-gray-500
                  h
                  over:text-gray-700
                "
              >
                {{ breadcrumb.url ? $t("message." + breadcrumb.url.name) : "" }}
              </router-link>
              <span
                v-else
                class="
                  ml-4
                  text-sm
                  font-medium
                  text-rose-500
                  hover:text-rose-700
                "
              >
                {{ breadcrumb.url ? $t("message." + breadcrumb.url.name) : "" }}
              </span>
            </div>
          </li>
        </span>
      </template>

      <template v-else>
        <span v-for="breadcrumb in breadcrumbs.list" :key="breadcrumb.index">
          <li>
            <div class="flex items-center">
              <ChevronRightIcon
                class="flex-shrink-0 h-5 w-5 text-gray-400"
                aria-hidden="true"
              />

              <router-link
                v-if="breadcrumb.route"
                :to="breadcrumb.route"
                class="
                  ml-4
                  text-sm
                  font-medium
                  text-gray-500
                  h
                  over:text-gray-700
                "
              >
                {{
                  breadcrumb.label
                    ? $t("message." + breadcrumb.label)
                    : breadcrumb.text
                }}
              </router-link>
              <span
                v-else
                class="
                  ml-4
                  text-sm
                  font-medium
                  text-gray-500
                  hover:text-gray-700
                "
              >
                {{
                  breadcrumb.label
                    ? $t("message." + breadcrumb.label)
                    : breadcrumb.text
                }}
                
              </span>
            </div>
          </li>
        </span>
      </template>
    </ol>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { ChevronRightIcon } from "@heroicons/vue/outline";

export default {
  name: "BreanCrumb",

  components: {
    ChevronRightIcon,
  },

  props: {
    disabled: {
      default: false,
      type: Boolean,
      required: false,
    },
    preset: {
      default: null,
      type: [Object, Array],
      required: false,
    },
  },

  data() {
    return {
      // page မှာ breadcrumb ui မပေါ်ချင်လျှင် အောက်က array list ထဲမှာ route name ထည့်ပေးလိုက်ရင် အဆင်ပြေပါပြီ။
      experts: ["index"],
    };
  },

  computed: {
    breadcrumbs() {
      return this.preset
        ? this.preset
        : this.$store.getters["cache/getBreadCrumbs"];
    },

    show() {
      return !this.experts.includes(this.$route.name);
    },
  },

  mounted() {
    // console.log(this.breadcrumbs);
  },
};
</script>